import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';

import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';
import * as COUNTRIES from '@teem/constants/country';
import { environment } from '@teem/environments/environment';

@Component({
  selector: 'merchant-info',
  templateUrl: './merchant-info.component.html',
  styleUrls: ['./merchant-info.component.css']
})

export class MerchantInfoComponent implements OnInit {
  activeTab: string = 'myfatoorah-tab';
  activeDeliveryTab: string = 'oto-tab';
  showMobileTab: boolean;
  showBusinessTab: boolean;
  userDetails: any = {};
  COUNTRIES: any = COUNTRIES;
  allowedEmails = ['bayan@aljaddah.sa', 'bander@Aljaddah.sa', 'bander@aljaddah.sa', 'bfakeih@gmail.com', 'ruba@aljaddah.sa', 'akbaras@teamvault.net'];

  creditCardTabsVisible: creditCardTabs = {
    hala: false,
    halaBusiness: false,
    momkn: false,
    hyperpay: true,
    myfatoorah: false,
    moyasar: false
  };

  merchantEnabled: merchantEnabled = {
    cash: false,
    stcpay: false,
    paypal: false,
    stripe: false,
    opay: false,
    banktransfer: false,
    creditCard: false,
    tap: false,
    paylink: false,
    myfatoorah: false,
    moyasar: false,
    foodics: false,
    tamara: false
  }

  merchantTabsVisible: merchantTabType = {
    stcpay: false,
    paypal: false,
    stripe: false,
    opay: false,
    banktransfer: false,
    creditCard: false,
    tap: false,
    paylink: false,
    myfatoorah: false,
    moyasar: false,
    foodics: false,
    tamara: false
  }

  deliveryEnabled: deliveryEnabled = {
    delivery: false,
    otoDelivery: false,
    careemDelivery: false,
  }

  deliveryTabsVisible: deliveryTabType = {
    delivery: false,
    otoDelivery: false,
    careemDelivery: false
  }

  constructor(
    private userService: UserService,
    private sharedDataService: SharedDataService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void { }

  @Input('userDetails')
  set getInfo(val: any) {
    this.userDetails = val;
    this.updateTabs();
    this.cdr.detectChanges();
  }

  hasStore() {
    return this.userDetails.has_store ? this.userDetails.has_store : false;
  }

  isEnabledPaymentModel(paymentModel: string): boolean {    
    if (paymentModel == 'paypal' && COUNTRIES.PAYPAL_SUPPORTED_COUNTRY.some(x => x == this.userDetails.country_id)) {
      return true;
    } else if (paymentModel == 'stripe' && COUNTRIES.STRIPE_SUPPORTED_COUNTRY.some(x => x == this.userDetails.country_id)) {
      return true;
    } else if (paymentModel == 'opay' && COUNTRIES.OPAY_SUPPORTED_COUNTRY.some(x => x == this.userDetails.country_id)) {
      return true;
    }
    return false;
  }

  isEnabledPayment(): boolean {    
    if (this.userDetails.country_id == COUNTRIES.SAUDI_ARABIA) {
      return true;
    }
    return false;
  }

  switchTab(tab: string) {
    this.activeTab = tab;
  }

  switchDeliveryTab(tab: string) {
    this.activeDeliveryTab = tab;
  }

  updateUserDetails(details) {
    this.userDetails = details;
    this.updateTabs();
  }


  updateTabs() {

    this.merchantEnabled = {
      cash: false,
      stcpay: false,
      paypal: false,
      stripe: false,
      opay: false,
      banktransfer: false,
      creditCard: false,
      tap: false,
      paylink: false,
      myfatoorah: false,
      moyasar: false,
      foodics: false,
      tamara: false
    }

    this.merchantTabsVisible = {
      stcpay: false,
      paypal: false,
      stripe: false,
      opay: false,
      banktransfer: false,
      creditCard: false,
      tap: false,
      paylink: false,
      myfatoorah: false,
      moyasar: false,
      foodics: false,
      tamara: false
    }

    if (this.userDetails) {

      console.log('this.userDetailswrerwewer:')
      console.log(this.userDetails)

      this.merchantEnabled.tap = true;

      if (this.userDetails.accept_cash_payment) {
        this.merchantEnabled.cash = true;
      }

      if (this.userDetails.accept_stcpay_payment && this.userDetails.stcpay_merchant_id && this.userDetails?.subscription.subscription_status != 'free') {
        this.merchantEnabled.stcpay = true;
        this.merchantTabsVisible.stcpay = true;
      }

      if (this.userDetails.accept_tamara && this.userDetails.tamara_access_token && this.userDetails?.subscription.subscription_status != 'free') {
        this.merchantEnabled.tamara = true;
        this.merchantTabsVisible.tamara = true;
      }

      if (this.userDetails.accept_paypal_payment && this.userDetails?.subscription.subscription_status != 'free') {
        this.merchantEnabled.paypal = true;
        this.merchantTabsVisible.paypal = true;
      }

      if (this.userDetails.accept_stripe_payment && this.userDetails?.subscription.subscription_status != 'free') {
        this.merchantEnabled.stripe = true;
        this.merchantTabsVisible.stripe = true;
      }

      if (this.userDetails.accept_opay_payment && this.userDetails?.subscription.subscription_status != 'free') {
        this.merchantEnabled.opay = true;
        this.merchantTabsVisible.opay = true;
      }

      if (this.userDetails.accept_foodics && this.userDetails?.subscription.subscription_status != 'free') {
        this.merchantEnabled.foodics = true;
        this.merchantTabsVisible.foodics = true;
      }

      this.merchantEnabled.creditCard = this.isInvoicePaymentCheckbox();
      this.merchantTabsVisible.creditCard = this.showInvoicePaymentTab();

      this.deliveryEnabled.delivery = this.isDeliveryOrderCheckbox();
      this.deliveryTabsVisible.delivery = this.showDeliveryTab();

      if (this.userDetails?.setting?.payment_info?.account_number) {
        if (this.userDetails.accept_bank_transfer) {
          this.merchantEnabled.banktransfer = true;
        }
        this.merchantTabsVisible.banktransfer = true;
      }
    }
  }

  /*
  this.checkHalaMobileTab();
        this.checkHalaHalaBusinessTab();
        if (this.showBusinessTab && !this.showMobileTab) {
          this.activeTab = 'halalah-tab';
        }
  */
  isInvoicePaymentCheckbox(): boolean {
    if ( this.userDetails.accept_credit_card && (this.userDetails.is_tap_contract_sign) && this.userDetails?.subscription.subscription_status != 'free' ) {
      return true;
    }
    return false;
  }


  showInvoicePaymentTab(): boolean {
    //if (this.userDetails.halala_mobile == null && this.userDetails.momkn_merchant_id == null)
    // if(this.userDetails.is_contract_sign && this.userDetails.hyperpay_info && this.userDetails.hyperpay_info.status =='active' && this.userDetails?.subscription.subscription_status != 'free'){
    //   this.merchantEnabled.creditCard = true;
    //   return true;
    // } else 
    if (this.userDetails.tap_info && this.userDetails.tap_info.status =='active' && this.userDetails?.subscription.subscription_status != 'free') {
      this.merchantEnabled.creditCard = true;
      return true;
    } else if(this.userDetails.myfatoorah_info && this.userDetails.myfatoorah_info.is_active && this.userDetails?.subscription.subscription_status != 'free') {
      this.merchantEnabled.creditCard = true;
      return true;
    } else if(this.userDetails.moyasar_info && this.userDetails.moyasar_info.is_active && this.userDetails?.subscription.subscription_status != 'free') {
      this.merchantEnabled.creditCard = true;
      return true;
    } else if(this.userDetails.paylink_info && this.userDetails.paylink_info.is_active && this.userDetails?.subscription.subscription_status != 'free') {
      this.merchantEnabled.creditCard = true;
      return true;
    } else if(this.userDetails.tap_merchant && (this.userDetails.tap_merchant.merchant_status == 'Active') && this.userDetails?.subscription.subscription_status != 'free') {
      this.merchantEnabled.creditCard = true;
      return true;
    } else {
      this.merchantEnabled.creditCard = false;
      return false;
    }
  }

  showTamaraPaymentTab(): boolean {
    if(this.userDetails.tamara_access_token && this.userDetails?.tamara_access_token != 'free'){
      this.merchantEnabled.tamara = true;
      return true;
    }
    else{
      this.merchantEnabled.tamara = false;
      return false;
    }
  }

  showStcpayPaymentTab(): boolean {
    if(this.userDetails.stcpay_merchant_id && this.userDetails?.subscription.subscription_status != 'free'){
      this.merchantEnabled.stcpay = true;
      return true;
    }
    else{
      this.merchantEnabled.stcpay = false;
      return false;
    }
  }

  showPaypalPaymentTab(): boolean {
    if(this.userDetails.payment_model.paypal_is_active && this.userDetails?.subscription.subscription_status != 'free'){
      this.merchantEnabled.paypal = true;
      return true;
    }
    else{
      this.merchantEnabled.paypal = false;
      return false;
    }
  }

  showStripePaymentTab(): boolean {
    if(this.userDetails.payment_model.stripe_is_active && this.userDetails?.subscription.subscription_status != 'free'){
      this.merchantEnabled.stripe = true;
      return true;
    }
    else{
      this.merchantEnabled.stripe = false;
      return false;
    }
  }

  showOpayPaymentTab(): boolean {
    if(this.userDetails.payment_model.opay_is_active && this.userDetails?.subscription.subscription_status != 'free'){
      this.merchantEnabled.opay = true;
      return true;
    }
    else{
      this.merchantEnabled.opay = false;
      return false;
    }
  }

  showFoodicsPaymentTab(): boolean {
    if(this.userDetails.marketplace_model.foodics_is_active && this.userDetails?.subscription.subscription_status != 'free'){
      this.merchantEnabled.foodics = true;
      return true;
    }
    else{
      this.merchantEnabled.foodics = false;
      return false;
    }
  }

  checkHalaMobileTab() {

    if (this.userDetails.hala_merchant_name != null) {
      this.showMobileTab = false;
    } else {
      this.showMobileTab = true;
    }
  }

  checkHalaHalaBusinessTab() {

    if (this.userDetails.halala_mobile != null && this.userDetails.hala_merchant_name == null) {
      this.showBusinessTab = false;
    } else {
      this.showBusinessTab = true;
    }
  }

  isDeliveryOrderCheckbox(): boolean {
    if ( this.userDetails.accept_delivery_order && this.userDetails?.subscription.subscription_status != 'free' ) {
      return true;
    }
    return false;
  }

  showDeliveryTab(): boolean {
    if(((this.userDetails?.oto_info?.is_active && this.userDetails?.oto_info?.is_enable) || this.userDetails?.accept_careem || this.userDetails?.accept_mrsool) && this.userDetails?.subscription.subscription_status != 'free'){
      this.deliveryEnabled.delivery = true;
      return true;
    } else{
      this.deliveryEnabled.delivery = false;
      return false;
    }
  }

  showHidePaymentTab(event, tab) {
    event.preventDefault();
    let options = {
      bankTransferPayment: 'banktransfer',
      acceptCardPayment: 'creditCard',
      acceptTapPayment: 'tap',
      acceptPaylinkPayment: 'paylink',
      acceptMyfatoorahPayment: 'myfatoorah',
      stcPayPayment: 'stcpay',
      paypalPayment: 'paypal',
      stripePayment: 'stripe',
      opayPayment: 'opay',
      foodicsMarketplace: 'foodics',
      acceptTamara: 'tamara'
    }
    let newTab = options[tab] ? options[tab] : null;

    if (newTab && this.merchantTabsVisible.hasOwnProperty(newTab)) {
      this.merchantTabsVisible[newTab] = !(this.merchantTabsVisible[newTab]);
    }
  }

  updatePaymentTab(event, tab) {
    console.log("Event: "+event);
    console.log("Tab: "+tab);
    event.preventDefault();

    let status: boolean = false;
    let options = {
      cashPayment: 'accept_cash_payment',
      bankTransferPayment: 'accept_bank_transfer',
      acceptCardPayment: 'accept_credit_card',
      acceptTapPayment: 'accept_tap',
      acceptPaylinkPayment: 'accept_paylink',
      stcPayPayment: 'accept_stcpay_payment',
      acceptTamara: 'accept_tamara',
      paypalPayment: 'accept_paypal_payment',
      stripePayment: 'accept_stripe_payment',
      opayPayment: 'accept_opay_payment',
      foodicsMarketplace: 'accept_foodics'
    }
    status = !event.target.checked;

    if (options[tab])
      this.updatePaymentOption(options[tab], status);
  }

  updatePaymentOption(payment_option, status) {
    this.userService.updatePaymentOption({ 'payment_option': payment_option, 'status': status }).subscribe(
      (res: any) => {
        let user = this.sharedDataService.getItem('userInfo');
        user.accept_cash_payment = res.data.accept_cash_payment;
        user.accept_stcpay_payment = res.data.accept_stcpay_payment;
        user.accept_bank_transfer = res.data.accept_bank_transfer;
        user.accept_credit_card = res.data.accept_credit_card;
        user.accept_paypal_payment = res.data.accept_paypal_payment;
        user.accept_stripe_payment = res.data.accept_stripe_payment;
        user.accept_foodics = res.data.accept_foodics;
        user.setting = res.data.setting;
        user.has_logo = res.data.has_logo;
        user.logo = res.data.logo;
        user.country_id = res.data.country_id;
        user.preference = res.data.preference;
        this.sharedDataService.setItem('userInfo', user);
        (window as any).userInfo.accept_cash_payment = res.data.accept_cash_payment;
        this.updateUserDetails(user);
      });
    return false;
  }

  showHideDeliveryTab(event, tab) {
    event.preventDefault();
    let options = {
      delivery: 'delivery',
    }
    let newTab = options[tab] ? options[tab] : null;
    if (newTab && this.deliveryTabsVisible.hasOwnProperty(newTab)) {
      this.deliveryTabsVisible[newTab] = !(this.deliveryTabsVisible[newTab]);
    }
  }

  updateDeliveryTab(event, tab) {
    event.preventDefault();
    let status: boolean = false;
    let options = {
      delivery: 'delivery',
    }
    status = !event.target.checked;

    if (options[tab])
      this.updateDeliveryOption(options[tab], status);
  }

  updateDeliveryOption(delivery_option, status) {
    this.userService.updatePaymentOption({ 'delivery_option': delivery_option, 'status': status }).subscribe(
      (res: any) => {
        let user = this.sharedDataService.getItem('userInfo');
        // user.oto = res.data.oto_info;
        user.accept_careem = res.data.accept_careem;
        user.accept_delivery_order = res.data.accept_delivery_order;
        user.accept_oto = res.data.accept_oto;
        user.uuid = res.data.uuid;
        
        this.sharedDataService.setItem('userInfo', user);
        this.updateUserDetails(user);
      });
    return false;
  }

  generateAuthUrl() {
    const foodicsUrl = environment.foodicsUrl;
    const teemUrl = environment.baseUrl;
    const clinetId = environment.clientId;
    const query = new URLSearchParams({
      'client_id': clinetId,
      "redirect_uri": `${teemUrl}/foodics/callback`,
      "response_type": "code",
      // "scope": "",
      "state": this.userDetails.uuid // this.randomString(40)
    }).toString();    
    (window as any).open(`${foodicsUrl}/authorize?${query}`, '_self');    
  }

  randomString(length) {
    var result = '';
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  scrollToPlanTab() {
    let element = document.getElementById("targetScroll");
    setTimeout(function(){
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
     }, 700);
  }
}


export interface creditCardTabs {
  hala: boolean,
  halaBusiness: boolean,
  momkn: boolean,
  hyperpay: boolean,
  myfatoorah: boolean,
  moyasar: boolean
}

export interface merchantEnabled {
  cash: boolean,
  stcpay: boolean,
  paypal: boolean,
  stripe: boolean,
  opay: boolean,
  banktransfer: boolean,
  creditCard: boolean,
  tap: boolean,
  paylink: boolean,
  myfatoorah: boolean,
  moyasar: boolean,
  foodics: boolean,
  tamara: boolean
}

export interface merchantTabType {
  stcpay: boolean,
  paypal: boolean,
  stripe: boolean,
  opay: boolean,
  banktransfer: boolean,
  creditCard: boolean,
  tap: boolean,
  paylink: boolean,
  myfatoorah: boolean,
  moyasar: boolean,
  foodics: boolean,
  tamara: boolean
}

export interface deliveryEnabled {
  delivery: boolean,
  otoDelivery: boolean,
  careemDelivery: boolean,
}

export interface deliveryTabType {
  delivery: boolean,
  otoDelivery: boolean,
  careemDelivery: boolean,
}